import {
  createSlice,
  createEntityAdapter,
  createSelector,
  PayloadAction,
} from '@reduxjs/toolkit';
import { RootState } from 'state/store';
import { BusinessUnitSummary } from 'types/store/normalized/businessUnit';

const businessTeamsAdapter = createEntityAdapter<BusinessUnitSummary>();
const initialState = businessTeamsAdapter.getInitialState();

const businessTeamsSlice = createSlice({
  name: 'projectsList/include/businessTeams',
  initialState,
  reducers: {
    updateBusinessTeams: (
      state,
      action: PayloadAction<{
        businessTeams: BusinessUnitSummary[];
        shouldReplace: boolean;
      }>
    ) => {
      const { businessTeams, shouldReplace } = action.payload;
      if (shouldReplace) {
        businessTeamsAdapter.setAll(state, businessTeams);
      } else {
        businessTeamsAdapter.upsertMany(state, businessTeams);
      }
    },
    removeAllBusinessTeams: (state) => {
      businessTeamsAdapter.removeAll(state);
    },
  },
});

export const { updateBusinessTeams, removeAllBusinessTeams } =
  businessTeamsSlice.actions;

const selectBusinessTeams = (state: RootState) =>
  state.projectsList.include.businessTeams;

export const { selectAll: selectAllBusinessTeams } =
  businessTeamsAdapter.getSelectors<RootState>(selectBusinessTeams);

export const selectBusinessTeamsById = createSelector(
  [selectAllBusinessTeams, (_, businessTeams: string[]) => businessTeams],
  (businessTeams, businessTeamsIds) => {
    return businessTeams.filter((businessTeam) =>
      businessTeamsIds.includes(businessTeam.id)
    );
  }
);

export default businessTeamsSlice.reducer;
